export interface Release {
    version: string;
    date: string;
    changeGroups: ChangeGroup[];
}

export interface ChangeGroup {
    apiId: string;
    additions?: Change[];
    updates?: Change[];
}

export interface Change {
    description: string;
    endpoints: {
        operationId: string;
        method: string;
        shortPath: string;
    }[];
    fieldsHeader?: string;
    fields?: string;
    filtersHeader?: string;
    filters?: string;
}

export const releases: Release[] = [];

// Import all .json files and add them to the releases array:
const context = require.context('./', false, /\.json$/);
context.keys().forEach(key => {
    releases.push({ version: key.match(/^\.\/(.+)\.json$/)![1], ...context(key) });
});
releases.sort((release1, release2) => release2.date.localeCompare(release1.date));
